import { useMemo } from 'react';
import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    { field: 'scan_date', headerName: 'Date', width: 110, valueFormatter: (params) => {
        if (!params.value) return '';
        const [y, m, d] = params.value.split('-');
        return `${m}-${d}-${y}`;
    } },
    { field: 'dc_name',          headerName: 'DC',            width: 140 },
    { field: 'door_name',        headerName: 'Door',          width: 120 },
    { field: 'transaction_time', headerName: 'Time',          width: 100 },
    { field: 'rfid',             headerName: 'RFID (EPC)',    width: 180 },
    { field: 'sscc_local_route', headerName: 'Route',         width: 100 },
    { field: 'stop_number',      headerName: 'Stop Number',   width: 130, type: 'number' },
    { field: 'pallet_id',        headerName: 'Pallet ID',     width: 150 },
    { field: 'planned_door',     headerName: 'Planned Door',  width: 130 },
    { field: 'movement_type',    headerName: 'Movement Type', width: 130 }
];

const DoorDetailsGridPanel = ({ allDoorDetailsData, filters }) => {

    const doorGroups = useMemo(() => {
        if (!allDoorDetailsData || allDoorDetailsData.length === 0) return [];
        const selectedDoor = filters.door ? filters.door.id : null;
        const map = new Map();
        for (const row of allDoorDetailsData) {
            const door = row.door_name || '(Unknown)';
            if (selectedDoor && door !== selectedDoor) continue;
            if (!map.has(door)) map.set(door, []);
            map.get(door).push(row);
        }
        for (const [, rows] of map) {
            rows.sort((a, b) => {
                const aIsReturn = a.movement_type === 'Return' ? 1 : 0;
                const bIsReturn = b.movement_type === 'Return' ? 1 : 0;
                if (aIsReturn !== bIsReturn) return aIsReturn - bIsReturn;
                return (a.transaction_time || '').localeCompare(b.transaction_time || '');
            });
        }
        return Array.from(map.entries());
    }, [allDoorDetailsData, filters]);

    if (!allDoorDetailsData || allDoorDetailsData.length === 0) {
        return (
            <div style={{ width: '100%' }}>
                <DataGrid
                    autoHeight
                    rows={[]}
                    columns={columns}
                    hideFooter
                    disableSelectionOnClick
                />
            </div>
        );
    }

    return (
        <div style={{ width: '100%' }}>
            {doorGroups.map(([doorName, rows]) => (
                <div key={doorName} style={{ marginBottom: '24px' }}>
                    <div style={{
                        padding: '6px 12px',
                        backgroundColor: '#e8eaf6',
                        fontWeight: 'bold',
                        fontSize: '13px',
                        borderLeft: '4px solid #3f51b5'
                    }}>
                        {doorName}
                    </div>
                    <DataGrid
                        autoHeight
                        rows={rows}
                        columns={columns}
                        hideFooter
                        disableSelectionOnClick
                        getRowId={(row) => row.id}
                    />
                </div>
            ))}
        </div>
    );
};

const mapStateToProps = (state) => ({
    allDoorDetailsData: state.loadValidationDashboard.doorDetailsData,
    filters: state.loadValidationDashboard.filters
});

export default connect(mapStateToProps)(DoorDetailsGridPanel);
